<template>
  <div class="lg:text-lg text-neutral-700">
    {{ text }}
    <button
      v-if="icon"
      type="button"
      class="ml-0.5 transition-all duration-300 hover:opacity-60"
      @click="$emit('icon-clicked', $event)"
    >
      <fa :icon="icon" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'VetsterSearchResultInfoHeading',

  props: {
    icon: {
      type: Array,
      default: null,
    },
    text: {
      type: String,
      default: '',
    },
  },
};
</script>
